export default __webpack_public_path__ + "static/media/6.a42562ad.png";